<template>
	<div style="position: relative;">
		<trainSearch :title="$route.path=='/downLoad'?'学习园地':'下载中心'" :isSearch="true"></trainSearch>
		<div class="container">
			<div style="display: flex;flex-direction: column;width: 17.8125rem;height: 3.75rem;margin: 0 1.25rem">
				<div @click="selectedItem=999" :class="selectedItem==999?'selectedItem profileHover':'profileHover'"
					style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin-bottom:0.3125rem;">
					全部
				</div>
				<div v-for="(item,index) in SelDocumentTypeData" @click="selectedItem=item.documentTypeId"
					:class="selectedItem==item.documentTypeId?'selectedItem profileHover':'profileHover'" style="cursor: pointer;background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					{{item.title}}
				</div>
				<!-- <div @click="selectedItem=3" :class="selectedItem==3?'selectedItem profileHover':'profileHover'" style="cursor: pointer;background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					动物实验相关
				</div>
				<div @click="selectedItem=4" :class="selectedItem==4?'selectedItem profileHover':'profileHover'" style="cursor: pointer;background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
				height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					科研服务相关
				</div> -->
			</div>
			<div style="width: 892px;
			background: #FFFFFF;
			padding: 0 3.55rem;
border-radius: 4px;box-shadow: 0 0.525rem 0.5625rem 0.3125rem rgba(129, 129, 129,0.1);">
				<div v-show="selectedItem==999" class="downCard" v-for="(item,index) in allData" :key="index+'1'">
					<p style="margin: 0;font-size: 1rem;">
						{{item.documentName}}
					</p>
					<p style="flex: 1;margin: 0;font-size: 1rem;color: lightgray;">
						（{{item.createTime.slice(0,10)}}）
					</p>
					<div v-show="item.downloadPath!==''" class="downHover" style="cursor: pointer;"
						@click="downloadFile(item)">
						<a-icon type="download" />
					</div>

				</div>
				<downCard :ids="'空'" v-show="selectedItem==999"></downCard>
				<downCard :ids="item.documentTypeId" v-for="(item,index) in SelDocumentTypeData"
					v-show="selectedItem==item.documentTypeId"></downCard>
				<!-- <div v-show="selectedItem==1" class="downCard" v-for="(item,index) in allData" :key="index+'1'">
						<p style="margin: 0;font-size: 1rem;">
							{{item.documentName}}
						</p>
						<p style="flex: 1;margin: 0;font-size: 1rem;color: lightgray;">
							（{{item.createTime.slice(0,10)}}）
						</p>
						<div v-show="item.downloadPath!==''" class="downHover" style="cursor: pointer;"  @click="downloadFile(item)">
							<a-icon  type="download" />
						</div>
						
				</div> -->
				<!-- <div v-show="allData.length==0&&selectedItem==1">
					
					<a-result  title="暂无数据">
					   
					  </a-result>
				</div> -->
				<!-- <div v-show="selectedItem==2" class="downCard" v-for="(item,index) in EntryData" :key="index+'2'">
					<p style="margin: 0;font-size: 1rem;">
						{{item.documentName}}
					</p>
					<p style="flex: 1;margin: 0;font-size: 1rem;color: lightgray;">
						（{{item.createTime.slice(0,10)}}）
					</p>
					<div class="downHover" style="cursor: pointer;"  @click="downloadFile(item)">
						<a-icon type="download" />
					</div>

				</div> -->
				<!-- <div v-show="EntryData.length==0&&selectedItem==2">
					
					<a-result  title="暂无数据">
					   
					  </a-result>
				</div> -->
				<!-- <div v-show="selectedItem==3" class="downCard" v-for="(item,index) in animalData" :key="index+'3'">
					<p style="margin: 0;font-size: 1rem;">
						{{item.documentName}}
					</p>
					<p style="flex: 1;margin: 0;font-size: 1rem;color: lightgray;">
						（{{item.createTime.slice(0,10)}}）
					</p>
					<div class="downHover" style="cursor: pointer;"  @click="downloadFile(item)">
						<a-icon type="download" />
					</div>
				
				</div> -->
				<!-- <div v-show="animalData.length==0&&selectedItem==3">
					
					<a-result  title="暂无数据">
					   
					  </a-result>
				</div> -->
				<!-- 	<div v-show="selectedItem==4" class="downCard" v-for="(item,index) in serviceData" :key="index+'4'">
					<p style="margin: 0;font-size: 1rem;">
						{{item.documentName}}
					</p>
					<p style="flex: 1;margin: 0;font-size: 1rem;color: lightgray;">
						（{{item.createTime.slice(0,10)}}）
					</p>
					<div class="downHover" style="cursor: pointer;" @click="downloadFile(item)">
						<a-icon  type="download" />
					</div>
				</div> -->
				<div v-show="serviceData.length==0&&selectedItem==1">

					<a-result title="暂无数据">

					</a-result>
				</div>


			</div>

		</div>
		<!-- <div style="position: absolute;bottom: 10px;right: 700px" v-for="(item,index) in check" v-show="item==1">
				<a-pagination :defaultPageSize="5" :pageSizeOptions="['5', '10', '20', '40']" v-model="queryPage.current"
					@showSizeChange="changeSize" @change="changeCurrent"
					style="display: block !important;margin-left: 15.625rem" :total="`${selectedItem==1?allLength:selectedItem==2?entryLength:selectedItem==3?animalLength:serviceLength}`" size="small"  show-size-changer
					show-quick-jumper />
			</div> -->
	</div>

</template>

<script>
	import moment from 'moment'
	import axios from 'axios'
	import {
		SelDocument,
		SelDocumentType
	} from '@/api/index.js'
	import trainSearch from '../../components/trainSearch.vue'
	import downCard from '../../components/downCard.vue'
	export default {
		name: '/downLoad',
		components: {
			trainSearch,
			downCard
		},
		data() {
			return {
				SelDocumentTypeData: [],
				allLength: 0,
				entryLength: 0,
				animalLength: 0,
				serviceLength: 0,
				check: [1, 2, 3, 4],
				queryPage: {
					current: 1,
					pageSize: 5
				},
				allData: [],
				EntryData: [],
				animalData: [],
				serviceData: [],
				selectedItem: 999,
			}
		},
		created() {
			SelDocumentType({
				LabId: this.$route.path == '/downLoad' ? 2 : 26
			}).then((res) => {
				this.SelDocumentTypeData = res.data.data
				console.log(res)
				console.log("测试")
			})

			// this.getAllData({type:undefined,name:'',page:1,row:5})
			// this.getEntry({type:1,name:'',page:1,row:5})
			// this.getAnimalData({type:2,name:'',page:1,row:5})
			// this.getServiceData({type:3,name:'',page:1,row:5})
		},
		watch: {
			$route(to, from) {
				SelDocumentType({
					LabId: this.$route.path == '/downLoad' ? 2 : 26
				}).then((res) => {
					this.SelDocumentTypeData = res.data.data
					console.log(res)
					console.log("测试")
				})
			}
		},
		methods: {
			async getAllData(data) {
				const res = await SelDocument(data)
				this.allData = res.data.data
				this.allLength = res.data.totalCount

			},
			async getEntry(data) {
				const res = await SelDocument(data)
				this.EntryData = res.data.data
				this.entryLength = res.data.totalCount
			},
			async getAnimalData(data) {
				const res = await SelDocument(data)
				this.animalData = res.data.data
				this.animalLength = res.data.totalCount
			},
			async getServiceData(data) {
				const res = await SelDocument(data)
				this.serviceData = res.data.data
				this.serviceLength = res.data.totalCount
			},
			downloadFile(val) {
				window.open(val.downloadPath, '_blank')

				// window.location.href =  val.downloadPath

				// var test = window.open()
				// setTimeout(function() {
				// 	console.log(val)
				//   test.location = val.downloadPath
				// }, 1)
				// let url = val.downloadPath
				// console.log(val.downloadPath)
				// let fileName = 'ddd.txt'
				// let mime = 'txt'
				//  axios.get(url, { responseType: 'blob' })
				//     .then(res => {
				//       let blob = new Blob([res.data], { type: mime }) 
				//       // 注: mime类型必须整正确, 否则下载的文件会损坏
				//         if (window.navigator && window.navigator.msSaveOrOpenBlob) { // 兼容IE
				//           window.navigator.msSaveOrOpenBlob(blob, element.original_name);
				//         } else {
				//           let downloadElement = document.createElement('a');
				//           downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
				//           downloadElement.download = fileName;
				//           downloadElement.click();
				//           window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
				//         }
				//     })
				//     .catch(error => {
				//       console.error(error)
				//     })
				// console.log(val)
			},
			changeCurrent(val) {
				this.queryPage.current = val
				switch (this.selectedItem) {
					case 1:
						let queryPage1 = {
							type: undefined,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: ""
						}
						this.getAllData(queryPage1);
						break;
					case 2:
						let queryPage2 = {
							type: 1,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: ""
						}
						this.getEntry(queryPage2);
						break;
					case 3:
						let queryPage3 = {
							type: 2,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: ""
						}
						this.getAnimalData(queryPage3);
						break;
					case 4:
						let queryPage4 = {
							type: 3,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: ""
						}
						this.getServiceData(queryPage4);
						break;
				}

			},
			changeSize(current, size) {
				console.log(current, size)
				this.queryPage.pageSize = size
				this.queryPage.current = current
				switch (this.selectedItem) {
					case 1:
						let queryPage1 = {
							type: undefined,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: "",
							LabId: 2
						}
						this.getAllData(queryPage1);
						break;
					case 2:
						let queryPage2 = {
							type: 1,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: ""
						}
						this.getEntry(queryPage2);
						break;
					case 3:
						let queryPage3 = {
							type: 2,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: ""
						}
						this.getAnimalData(queryPage3);
						break;
					case 4:
						let queryPage4 = {
							type: 3,
							page: this.queryPage.current,
							row: this.queryPage.pageSize,
							name: ""
						}
						this.getServiceData(queryPage4);
						break;
				}
			}
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		display: flex;
		background-color: #F6F8FA;
		height: 100%;
		min-height: 25.5rem;
		justify-content: center;
		padding-top: 3.75rem;
		padding-bottom: 12.6875rem;

	}

	.downCard {
		display: flex;
		align-items: center;
		width: 100%;
		height: 5.75rem;
		/* margin: 0 3.55rem; */
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);
		transition-duration: 0.25s;
	}

	.downCard:hover {
		color: #1890FF;
		transform: scale(1.01);

	}

	.selectedItem {
		background: #1890FF !important;
		color: white;
	}

	.downHover:hover {
		color: #1890FF;
	}
</style>